// Per-route column configurations for InvoiceTable.
//
// Each column descriptor:
//   key       — unique id, also used as the sort key
//   label     — column header text (verbatim per route, as specified by product)
//   align     — 'left' | 'right' | 'center' (default 'left')
//   sortable  — whether the column header is clickable to sort (default true)
//   type      — 'text' | 'date' | 'pill' — controls default cell rendering
//   getValue  — (invoice) => raw value, used both for sorting and default rendering

const place = (invoice) => (invoice.client_group ? invoice.client_group.external_identifier : 'Sem grupo')
const reason = (invoice) => (invoice.reprove_reason ? invoice.reprove_reason.reason : 'Sucesso')

export const COLUMNS = {
  user: { key: 'user', label: 'Utilizador', type: 'text', getValue: (i) => i.user },
  number: { key: 'invoice_number', label: 'Nº Fatura', type: 'text', getValue: (i) => i.invoice_number },
  place: { key: 'place', label: 'Estabelecimento', type: 'text', getValue: place },
  invoiceDate: { key: 'invoice_date', label: 'Data Fatura', type: 'date', getValue: (i) => i.invoice_date },
  createdAt: { key: 'created_at', label: 'Data Registo', type: 'date', getValue: (i) => i.created_at },
  estado: { key: 'estado', label: 'Estado', type: 'pill', sortable: false, getValue: () => null },
  reason: { key: 'reason', label: 'Razão', type: 'text', sortable: false, getValue: reason },
}

// /invoice/to_validate — Utilizador, Nº Fatura, Estabelecimento, Data Fatura, Data Registo, (eye)
export const TO_VALIDATE_COLUMNS = [
  COLUMNS.user,
  COLUMNS.number,
  COLUMNS.place,
  COLUMNS.invoiceDate,
  COLUMNS.createdAt,
]

// /invoice/validated — same as to_validate + Estado and Razão (a refused
// invoice must show why it was refused, as on /invoice/registered)
export const VALIDATED_COLUMNS = [
  COLUMNS.user,
  COLUMNS.number,
  COLUMNS.place,
  COLUMNS.invoiceDate,
  COLUMNS.createdAt,
  COLUMNS.estado,
  COLUMNS.reason,
]

// /invoice/created — Nº Fatura, Data fatura, Data registo, Ações (Editar/Eliminar)
export const CREATED_COLUMNS = [
  COLUMNS.number,
  { key: 'invoice_date', label: 'Data fatura', type: 'date', getValue: (i) => i.invoice_date },
  { key: 'created_at', label: 'Data registo', type: 'date', getValue: (i) => i.created_at },
]

// /invoice/to_approve — unchanged legacy set: Nº Fatura, Data Fatura, Data Registo, (eye)
export const TO_APPROVE_COLUMNS = [
  COLUMNS.number,
  { key: 'invoice_date', label: 'Data Fatura', type: 'date', getValue: (i) => i.invoice_date },
  { key: 'created_at', label: 'Data Registo', type: 'date', getValue: (i) => i.created_at },
]

// /invoice/registered — Nº Fatura, Fatura(date), Registo(date), Tipo Venda, Pontos, Estado, Razão, (eye)
export const REGISTERED_COLUMNS = [
  COLUMNS.number,
  { key: 'invoice_date', label: 'Fatura', type: 'date', getValue: (i) => i.invoice_date },
  { key: 'created_at', label: 'Registo', type: 'date', getValue: (i) => i.created_at },
  { key: 'sale_type', label: 'Tipo Venda', type: 'text', getValue: (i) => i.sale_type },
  { key: 'points', label: 'Pontos', type: 'text', align: 'right', getValue: (i) => i.points || 0 },
  COLUMNS.estado,
  COLUMNS.reason,
]
